const actions = {
    FETCH_USER_ATTENDANCE_PERMISSIONS: 'FETCH_USER_ATTENDANCE_PERMISSIONS',
    FETCH_USER_ATTENDANCE_PERMISSION: 'FETCH_USER_ATTENDANCE_PERMISSION',
    RESET_USER_ATTENDANCE_PERMISSION: 'RESET_USER_ATTENDANCE_PERMISSION',

    fetchUserPermissionsAction: (data) => {
        return {
            type: actions.FETCH_USER_ATTENDANCE_PERMISSIONS,
            data: data
        };
    },
    resetUserPermissionFormAction: () => {
        return {
            type: actions.RESET_USER_ATTENDANCE_PERMISSION,
            data: null
        };
    },
    fetchUserPermissionAction: (data) => {
        return {
            type: actions.FETCH_USER_ATTENDANCE_PERMISSION,
            data: data
        };
    },
};

export default actions;
